import { WorkflowStatusId } from 'types/enums/WorkflowStatus';

/**
 * A drawing may only be changed while it is still open or was rejected. Once it
 * is submitted for release or released it is frozen — the old app hides its edit
 * link the same way (`list_drawings.scala.html`: `STATE_OFFEN ||
 * STATE_ZURUECKGEWIESEN`). A drawing without a workflow row counts as frozen,
 * as in the old view.
 */
export const canEditDrawing = (workflowStatusId?: WorkflowStatusId): boolean =>
  workflowStatusId === WorkflowStatusId.OFFEN || workflowStatusId === WorkflowStatusId.ZURUECKGEWIESEN;
